import {lazy} from "react";
import Error from "@/components/error/error.tsx";
import {Route} from "react-router";

const ShopItemDetail = lazy(() => import("@/app/shop/features/shop-item/shop-item-detail.tsx"));
const ShoppingCartPage = lazy(() => import("@/app/shop/features/shopping-cart/shopping-cart-page.tsx"));
const Orders = lazy(() => import("@/app/shop/features/orders/orders.tsx"));
const ShoppingMall = lazy(() => import("@/app/shop/features/shopping-mall/shopping-mall.tsx"));
const Checkout = lazy(() => import("@/app/shop/features/checkout/checkout.tsx"));
const OrderDetail = lazy(() => import("@/app/shop/features/orders/features/order/order-detail.tsx"));
const ChecoutCompleteCheckPage = lazy(
    () => import("@/app/shop/features/checkout/steps/checkout-step-order-overview/checkout-complete-page.tsx")
);
const IngredientDetail = lazy(() => import("@/app/shop/features/ingredient-detail/ingredient-detail.tsx"));

const ShopRoutes= [
    <Route path="shop" element={<ShoppingMall />} errorElement={<Error/>} />,
    <Route path="shop/shopitem/:uuid" element={<ShopItemDetail />} errorElement={<Error/>} />,
    <Route path="shop/shopping-cart" element={<ShoppingCartPage />} errorElement={<Error/>} />,
    <Route path="customer/orders" element={<Orders />} errorElement={<Error/>} />,
    <Route path="customer/orders/:uuid" element={<OrderDetail />} errorElement={<Error/>} />,
    <Route path="customer/order/checkout" element={<Checkout />} errorElement={<Error/>} />,
    <Route path="checkout/complete" element={<ChecoutCompleteCheckPage />} errorElement={<Error/>} />,
    <Route path="shop/ingredient/:slug" element={<IngredientDetail />} errorElement={<Error/>} />,
];
export default ShopRoutes;
